import React, { Dispatch } from 'react';
import classes from './FindImagesProportionFilterGroup.module.scss';
import classNames from 'classnames';
import { FilterItem } from '../FilterItem';
import { FilterItemGroup } from '../FilterItemGroup';
import { Orientation } from '../../../models/graphql';
import { FindImagesFilterAction } from '../../../models/media';

export type FindImagesProportionFilterGroupViewProps = {
  loading: boolean;
  dispatchFilters: Dispatch<FindImagesFilterAction>;
  activeFilterId?: string;
};

export const FindImagesProportionFilterGroupView = (props: FindImagesProportionFilterGroupViewProps): JSX.Element => {
  const setSelectedFilter = (id: string) => {
    props.dispatchFilters({ type: 'proportion', payload: id });
  };

  const filterClasses = classNames('grid-x', 'align-left', 'align-middle');

  return (
    <FilterItemGroup isFiltered={!!props.activeFilterId} title={'Proportions'} resetHandler={() => setSelectedFilter('')} clearText='Clear'>
      <FilterItem
        selected={Orientation.HORIZONTAL === props.activeFilterId}
        loading={false}
        setSelectedHandler={() => setSelectedFilter(Orientation.HORIZONTAL)}>
        <div className={filterClasses}>
          <div className={`cell shrink ${classes.Label}`}>Wide</div>
        </div>
      </FilterItem>
      <FilterItem
        selected={Orientation.VERTICAL === props.activeFilterId}
        loading={false}
        setSelectedHandler={() => setSelectedFilter(Orientation.VERTICAL)}>
        <div className={filterClasses}>
          <div className={`cell shrink ${classes.Label}`}>Tall</div>
        </div>
      </FilterItem>
    </FilterItemGroup>
  );
};
